// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useEntity } from '@backstage/plugin-catalog-react';
import { TileBoundary } from '../team-landing/TileBoundary';

const FIGMA_FILE = 'figma.com/file';
const FIGMA_NODE = 'figma.com/node-id';

const buildUrl = (fileKey: string, nodeId?: string) => {
  const base = `https://www.figma.com/file/${encodeURIComponent(fileKey)}`;
  return nodeId ? `${base}?node-id=${encodeURIComponent(nodeId)}` : base;
};

const FigmaCardBody = () => {
  const { entity } = useEntity();
  const annotations = entity.metadata.annotations ?? {};
  const fileKey = annotations[FIGMA_FILE];
  const nodeId = annotations[FIGMA_NODE];
  if (!fileKey) return null;
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6">Figma</Typography>
        <Typography variant="body2" color="text.secondary">
          {nodeId
            ? 'Open the linked Figma frame for this component.'
            : 'Open the Figma file for this component.'}
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          variant="outlined"
          size="small"
          href={buildUrl(fileKey, nodeId)}
          target="_blank"
          rel="noreferrer"
          aria-label="Open Figma file for this component"
        >
          Open in Figma
        </Button>
      </CardActions>
    </Card>
  );
};

export const FigmaCard = () => (
  <TileBoundary tool="Figma">
    <FigmaCardBody />
  </TileBoundary>
);
